import React from 'react';
import md5 from 'md5';
import './CompetitionBestTodayWidget.scss';

const SVGHelper = {
    title: (value) => {
        const titleProps = {
            display: 'inline-block',
            height: '55',
            style: {
                fill: '#1E252E',
                fontSize: '36px',
                fontWeight: 400,
                verticalAlign: 'middle',
                paddingLeft: '10px',
            },
        };

        return (
            <svg {...titleProps}>
                <text y={35}>{value}</text>
            </svg>
        );
    },
    main: ({ mainValue, extraValue, specialColor }) => {
        const mainProps = {
            fontSize: 80,
            fontWeight: 500,
        };

        const extraProps = {
            fontSize: 30,
            fontWeight: 400,
            y: 60,
            style: { marginLeft: '20px' }
        };

        if (specialColor) {
            mainProps.fill = specialColor;
            extraProps.fill = specialColor;
        }

        let value = <text y={60} {...mainProps}>{mainValue}</text>;
        if (extraValue) {
            value = (
                <text y={60}>
                    <tspan width="100%" height="90" {...mainProps}>
                        {mainValue}
                    </tspan>
                    <tspan {...extraProps}>
                        {extraValue}
                    </tspan>
                </text>
            );
        }

        return (
            <svg width="100%" height="90">
                {value}
            </svg>
        );
    },
};

const CompetitionBestTodayWidget = (props) => {
    const { companyProfile, slide, widgetData } = props;
    const customTextColor = slide ? slide.custom.bgColor : companyProfile.colors.mainBg;

    const defaultWidgetData = widgetData && widgetData.length ? widgetData : [];

    if (!defaultWidgetData.length) {
        return (
            <div className="loading">
                Loading
                <i className="fa fa-refresh fa-spin fa-fw" aria-hidden="true" />
            </div>
        );
    }

    //get the best 3 for today
    let bestieList = getBestScorers(widgetData);

    let bestest = bestieList.map((best, i) => {
        let initials = getInitials(best.name);
        let hash = md5(best.email);

        return (<div className="comp-user-holder" key={i}><div title={best.name} className="userImage" style={{ background: customTextColor }}>
            <div className="user-initials">
                <span>{initials}</span>
            </div>
            <div style={{ position: "absolute" }}><img src={`//gravatar.com/avatar/${hash}?size=100&d=blank&r=x`} className="avatar" alt={best.name} /></div>
        </div></div>);

    });

    return (
        <div>
            <span className="fa fa-star fa-2x" style={{ color: customTextColor }} />
            {SVGHelper.title('Best of today')}
            <div style={{ display: "flex", justifyContent: "center" }}>{bestest}</div>
            <div style={{ textAlign: "center", fontSize: "50px", fontWeight: "900", color: customTextColor }}><span>{bestieList.length && bestieList[0].todaysScore} points</span></div>
        </div >
    );
};

function getBestScorers(widgetData) {
    let maxScore = _.maxBy(widgetData, 'todaysScore');
    let besties = _.filter(widgetData, row => row.todaysScore === maxScore.todaysScore);

    //just get 3
    if (besties.length > 3) {
        besties = _.take(besties, 3);
    }

    return besties;
}

function getInitials(user) {
    if (!user) {
        return '';
    }

    let i1 = '';
    let i2 = '';
    let nameArray = [];

    if (user) {
        i1 = user.charAt(0);
        nameArray = user.split(' ');

        if (nameArray.length > 2) {
            i2 = nameArray[nameArray.length - 1].charAt(0);
        } else if (nameArray.length === 2) {
            i2 = nameArray[1].charAt(0);
        }
    }

    return i1 + i2;
}

export default CompetitionBestTodayWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/CompetitionWidgets/CompetitionBestTodayWidget.jsx
 **/